'use strict';

const { generateResponsiveSlickCarousel } = require('../../common');

const $categorySlider = $('.plp-category-carousel');
const $leftArrowCategory = $('.plp-category-carousel-wrapper .left-arrow');
const $rightArrowCategory= $('.plp-category-carousel-wrapper .right-arrow');
const slidesToShowCategory = 4;
const slidesToScrollCategory = 1;
const slidesToShowCategoryTablet = 3;
const slidesToScrollCategoryTablet = 1;
const slidesToShowCategoryMobile = 2;
const slidesToScrollCategoryMobile = 1;
const infiniteCategory = false;
const visibleArrowsMobile = false;

var carouselOptions = {
    dots: false,
    hideDisabledArrows: true
};

try {
    if($categorySlider.length > 0) {
        $categorySlider.on('init', function (event, slick) {
            $categorySlider.removeClass('hide-category-tiles');
            
            // Get translatable strings from data attributes
            var $wrapper = $('.plp-category-carousel-slides-wrapper');
            var roleDescription = $wrapper.data('aria-roledescription') || 'category';
            var labelFallback = $wrapper.data('aria-label-fallback') || 'Category {0}';
            var labelPosition = $wrapper.data('aria-label-position') || '{0} of {1}: {2}';
            
            // Build a name map from non-cloned slides, then apply aria attributes
            // to both original and cloned slides using normalized indexes.
            var $slides = $categorySlider.find('.slick-slide');
            var totalSlides = slick.slideCount;
            var categoryNamesByIndex = {};

            $slides.each(function() {
                var $slide = $(this);
                var slideIndex = parseInt($slide.attr('data-slick-index'), 10);

                if (!Number.isNaN(slideIndex) && slideIndex >= 0 && slideIndex < totalSlides && !categoryNamesByIndex[slideIndex]) {
                    categoryNamesByIndex[slideIndex] = $slide.find('a').first().attr('aria-label') ||
                        $slide.find('.popular-category-title').text() ||
                        labelFallback.replace('{0}', slideIndex + 1);
                }
            });
            
            $slides.each(function() {
                var $slide = $(this);
                var rawSlideIndex = parseInt($slide.attr('data-slick-index'), 10);

                if (!Number.isNaN(rawSlideIndex) && totalSlides > 0) {
                    var normalizedSlideIndex = ((rawSlideIndex % totalSlides) + totalSlides) % totalSlides;
                    var categoryName = categoryNamesByIndex[normalizedSlideIndex] ||
                        labelFallback.replace('{0}', normalizedSlideIndex + 1);

                    var ariaLabel = labelPosition
                        .replace('{0}', normalizedSlideIndex + 1)
                        .replace('{1}', totalSlides)
                        .replace('{2}', categoryName);
                    
                    $slide.attr({
                        'role': 'group',
                        'aria-roledescription': roleDescription,
                        'aria-label': ariaLabel
                    });
                }
            });
        });
        
        // Update aria-hidden when slides change
        $categorySlider.on('afterChange', function() {
            var $slides = $categorySlider.find('.slick-slide');
            
            $slides.each(function() {
                var $slide = $(this);
                var isVisible = $slide.hasClass('slick-active');
                var $links = $slide.find('a');
                
                if (isVisible) {
                    $slide.attr('aria-hidden', 'false');
                    $links.attr('tabindex', '0');
                } else {
                    $slide.attr('aria-hidden', 'true');
                    $links.attr('tabindex', '-1');
                }
            });
        });
        
        generateResponsiveSlickCarousel($categorySlider , $leftArrowCategory, $rightArrowCategory, slidesToShowCategory, slidesToScrollCategory, slidesToShowCategoryMobile, slidesToScrollCategoryMobile, slidesToShowCategoryTablet, slidesToScrollCategoryTablet, infiniteCategory, visibleArrowsMobile, carouselOptions);
    }  else {
        console.warn('Category carousel selector not rendered');
    }
} catch (e) {
    console.error('Failed to initialize Category carousel:', e);
}